import React, { ImgHTMLAttributes } from 'react'
import { getCdnUrl } from './helper'

const CdnAssetImage: React.FC<{
  cdnPath: string
  alt?: string
  style?: ImgHTMLAttributes<HTMLImageElement>['style']
}> = ({ cdnPath, alt, style }) => {
  const assetUrl = getCdnUrl(cdnPath)

  return (
    <img
      src={assetUrl}
      alt={alt}
      style={style}
    />
  )
}

export { CdnAssetImage }
